.aha-comment__container {
  --aha-comment--top: 6px;
  display: flex;
  gap: var(--spacer-4);
  padding-bottom: var(--spacer-3);
  margin-top: var(--spacer-2);
}

.aha-comment__container--annotation {
  gap: var(--spacer-3);

  .aha-comment__content {
    border: 1px solid var(--theme-secondary-border);
    border-radius: var(--Common--border-radius);
    overflow: hidden;
    padding: 5px;
  }

  .aha-comment__header {
    font-size: 11px;
    margin-bottom: var(--spacer-5);
    padding-right: 5px;
    padding-top: var(--spacer-05);
  }

  .aha-comment__name {
    color: var(--theme-secondary-text);
    font-weight: 600;
  }

  .aha-comment__share-controls-hover {
    font-size: 10px;

    .aha-comment__share-controls-date {
      display: inherit;
    }
  }
}

.aha-comment__content {
  background-color: var(--theme-primary-background);
}

.aha-comment__container--child {
  padding-bottom: 0;
  margin-top: 0;
}

:host .line {
  display: flex;
  align-items: stretch;
  justify-content: center;
}

:host .line::before {
  content: '';
  background: var(--theme-primary-border);
  width: 2px;
}

fa-icon {
  color: var(--theme-primary-text);
}

.aha-comment__avatar-container {
  position: relative;
  display: grid;
  grid-template-rows: 28px auto;
  row-gap: var(--spacer-2);
}

.aha-comment__avatar-container--child {
  grid-template-rows: var(--aha-comment--top) 28px auto;
}

.aha-comment__avatar {
  width: 28px;
  height: 28px;
}

.aha-comment__share-controls {
  display: flex;
}

.aha-comment__share-controls-hover {
  display: flex;
  transition: opacity 0.2s;
}

.aha-comment__share-controls-hover.show {
  > * {
    display: inherit;
  }

  pointer-events: auto;
}

.aha-comment__share-controls-hover.hide {
  > * {
    display: none;
  }

  pointer-events: none;
}

.aha-comment__reply-button {
  cursor: pointer;
  color: var(--aha-blue-500);
  margin-right: var(--spacer-1);
}

.aha-comment__reply-button:hover {
  text-decoration: underline;
}

slot[name='share-controls']::slotted(*) {
  display: flex;
}

.aha-comment__share-controls-date {
  color: var(--theme-tertiary-text);
  padding-left: var(--spacer-1);
}

.aha-comment__content {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.aha-comment__content--child {
  margin-top: 14px;
}

.aha-comment__header {
  display: flex;
  justify-content: space-between;
  margin-bottom: var(--spacer-2);
  color: var(--theme-tertiary-text);
  padding-top: 6px;
}

.aha-comment__name {
  display: flex;
  gap: var(--spacer-2);
  padding-left: 5px;
}

.aha-comment__controls {
  display: flex;
  gap: var(--spacer-3);
  cursor: pointer;
  margin-bottom: 16px;
}

.aha-comment__controls .fa-arrow-turn-left-up {
  margin-bottom: 7px;
  margin-left: 4px;
  margin-right: 2px;
}

.aha-comment__controls .fa-arrow-turn-down-right {
  margin-bottom: 4px;
  margin-left: 6px;
  margin-right: 2px;
}

.aha-comment__controls a {
  display: flex;
  align-items: end;
  gap: var(--spacer-1);
  color: var(--aha-blue-500);
  margin-right: 3px;
}
